import { JsonObject, JsonProperty } from 'json2typescript';
import { Pagination } from '../../../shared/pagination-model';

@JsonObject('StoreFeesFilters')
export class StoreFeesFilters extends Pagination {
  @JsonProperty('storeCode', String, true) storeCode: string = undefined;
  @JsonProperty('logisticPartner', String, true) logisticPartner: string = undefined;
}
